import React from "react";
import { Box, Typography } from "@mui/material";
import Header from "shared/components/Header";

const PayrollPage = () => {
  return (
    <Box m="20px">
      <Header title="Payroll" subtitle="Service-enabled payroll module" />
      <Typography variant="body1" sx={{ mt: 2 }}>
        Payroll module is available for tenants with service code 111.
      </Typography>
    </Box>
  );
};

export default PayrollPage;
